import type { GmRewardType } from '@/components/entities/gamification/GmAwardCard/utils/types';
import type { GmRewardAction } from '@/components/features/gamification/model/types/gm-statuses';
import type { RewardTypeValue } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

export type GmRewardCardConfig = GmRewardType & {
  action?: GmRewardAction;
  /** Backend reward type; its grouped reward decides the card's availability and required status. */
  type?: RewardTypeValue;
};

// TODO: mock data is used
export const gamificationMockRewards: GmRewardCardConfig[] = [
  { title: 'Level UP Scratch Card', subTitle: 'up to 0.5 SC', imgKey: 'level-up-scratch-card', action: 'level-up-card', type: GamificationRewardType.LevelUp },
  { title: 'Status UP Scratch Card', imgKey: 'status-up-scratch-card', subTitle: 'Up to 2 SC', action: 'status-up-card', type: GamificationRewardType.StatusUp },
  { title: 'Loss insurance', imgKey: 'loss-insurance', subTitle: 'Up to xxx' },
  { title: 'Referral', imgKey: 'referral', subTitle: 'Up to 5,000 SC per friend' },
  { title: 'Birthday Bonus', imgKey: 'birthday-bonus', isClaim: true, statusName: 'bronze' },
  { title: 'Free spins', imgKey: 'free-spins', statusName: 'gold' },
  { title: 'Winners Pool', imgKey: 'winners-pool' },
  { title: 'Weekly Bonus', imgKey: 'weekly-playback', isClaim: true },
  { title: 'Monthly Bonus', imgKey: 'monthly-playback', isClaim: true },
];
